<template>
    <div class="footer bg-dark1 py-5">
        <div class="container row mx-auto">
            <div class="row pt-4 pb-2">
                <img src="../assets/img/logo/logo-name-white.svg" style="width: 150px;" alt="">
            </div>
            <hr style="">
            <div class="col-xl-12 row">
                <div class="col-lg-6">
                    <div style="font-size: 16px;font-weight: bold" class="my-3">ارتباط با ما</div>
                    <div class="my-3" style="cursor: pointer;font-size: 13px"><FontAwesomeIcon icon="fa-solid fa-phone-volume"/><span class="d-inline mx-3">۰۲۱۵۴۷۸۷۱۱۱</span></div>
                    <div class="my-3" style="cursor: pointer;font-size: 13px"><FontAwesomeIcon icon="fa-solid fa-envelope" /><span class="d-inline mx-3">info@heyvaai.com</span></div>
                    <div class="my-3" style="cursor: pointer;font-size: 13px"><FontAwesomeIcon icon="fa-solid fa-location-dot" /><span class="d-inline mx-3">اطلس مال، طبقه A1،واحد 14</span></div>
                </div>
                <div class="row col-lg-6 my-lg-0 my-4 mx-auto">
                    <div class="col-6 px-0">
                        <div style="font-size: 16px;font-weight: bold" class="my-3" @click="router.push({'name':'demo'})">هوش مصنوعی هیوا</div>
                        <div style="cursor: pointer;font-size: 13px"  class="my-2" @click="router.push({'name':'about'})">درباره ما</div>
                        <div style="cursor: pointer;font-size: 13px"  class="my-2" @click="router.push({'name':'contact'})">ارتباط با ما</div>
                        <div style="cursor: pointer;font-size: 13px"  class="my-2" @click="router.push({'name':'blogs'})">وبلاگ</div>
                        <div style="cursor: pointer;font-size: 13px"  class="my-2" @click="router.push({'name':'faq'})">سوالات متداول</div>
                    </div>
                    <div class="col-6 px-0">
                        <div style="font-size: 16px;font-weight: bold" class="my-3">لینک های سریع</div>
                        <div style="cursor: pointer;font-size: 13px"  class="my-2" >Chatbot</div>
                        <div style="cursor: pointer;font-size: 13px"  class="my-2" >QC</div>
                        <div style="cursor: pointer;font-size: 13px"  class="my-2" >MCI</div>
                    </div>
                </div>
            </div>
            
            <div class="col-12 text-end mt-3">
                <a href="https://www.instagram.com/heyvaai?igsh=dzI4eXZkdzNrN3Fl"><FontAwesomeIcon style="color: white;" class="m-2 fs-5" icon="fa-brands fa-instagram"/></a>
                <a href="https://www.linkedin.com/company/heyvaai"><FontAwesomeIcon style="color: white;" class="m-2 fs-5" icon="fa-brands fa-linkedin"/></a>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faPhoneVolume, faEnvelope, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { library } from '@fortawesome/fontawesome-svg-core';
import { useRouter } from 'vue-router';
import { faInstagram,faLinkedin } from '@fortawesome/free-brands-svg-icons';

export default defineComponent({
    components:{FontAwesomeIcon},
    setup(){
        const router = useRouter()
        library.add(faPhoneVolume,faEnvelope,faLocationDot,faInstagram,faLinkedin);

        return{router}
    }
})
</script>
<style scoped lang="scss">
.light-card{
    background-color: #ffffff0e;
    border: none;
    border-radius: 10px;
    padding: 15px;
}
.footer-input {
    background-color: #ffffff11;
    border: none;
    outline-style: none;
    border-radius: 5px;
    color: white;
    padding: 5px 10px;
}
.footer-button {
    background-color: #000;
    border: none;
    border-radius: 5px;
    color: white;
    padding: 5px 10px;
}
</style>